module.exports = __webpack_public_path__ + "media/images/VegasHD-8952b0c6d17dde639d8775ed5efa1f36.jpg";